import styled from "styled-components";

interface Props {
	id?: string;
}

export const Hr: React.FC<Props> = ({ id }) => {
	return <Styles id={id} />;
};

const Styles = styled.div`
	width: 100%;
	border-bottom: 2px solid ${(props) => props.theme.colors.dividerLight};
`;
